import jwtDecode from "jwt-decode";

const getToken = () => {
    try {
        let tokenJson = localStorage.getItem("token");
        return tokenJson ? JSON.parse(tokenJson) : null;
    } catch (err) {
        console.log(err);
    }
    return null;
}

export const auth = {
    isAuthenticated: () => !!getToken(),
    getAccessToken: () => {
        let token = getToken();
        return token ? token.access_token : '';
    },
    getRefreshToken: () => {
        let token = getToken();
        return token ? token.refresh_token : '';
    },
    getExpiresIn: () => {
        const accessToken = jwtDecode(JSON.parse(localStorage.getItem("token")).access_token)
        return accessToken ? accessToken.exp: 0;
    }
};